import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
    FaRegEye,
    FaBolt, 
    FaBan,
    FaClipboardList,
    FaChevronRight
} from "react-icons/fa";
import { BACKEND } from "../config/configEnvs";
import { FaSpinner } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";
import Draggable from "../components/ui/Dragable";
import ItemRowSeguimientoServiciosCliente from "../components/seguimiento/ItemRowSeguimientoServiciosCliente"

const SeguimientoServiciosCliente = ({}) => {

    const [client, setClient] = useState({})
    const [serviceDetails, setServiceDetails] = useState([])

    const { id, activeServices } = useParams();

    const fetchClient = async () => {
        try {
            const response = await axios.get(`${BACKEND}/api/clientesUser/${id}`);
            setClient(response.data);
        } catch (error) {
            console.error('Error fetching client data:', error);
        }
    };

    const fetchServiceDetails = async () => {
        try {
            const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones?where[cotizacion.cliente][equals]=${id}&where[servicio.name][like]=${activeServices}&limit=0`);
            const filteredData = response.data.docs.filter(item => item.cotizacion.estado === 'Exito');
            const sortedData = filteredData.sort((a, b) => new Date(b.fechaInicio) - new Date(a.fechaInicio))
            setServiceDetails(sortedData)
        } catch (error) {
            console.error('Error fetching service details:', error);
        }
    };

    function capitalizeWords(str) {
        if (!str) return '';
        return str
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
    }

    useEffect(() => {
        fetchClient()
        fetchServiceDetails();
    }, [id, activeServices])

    return (
        <div>
            <div className="flex flex-row px-4 py-2 overflow-x-auto bg-gray-100 mb-4">
                <div className="flex flex-row w-full items-center gap-4 justify-between">
                    <div className="flex items-center gap-4 py-4">
                        <FaClipboardList className="text-zinc-700 text-2xl" />
                        <Link to={'/home/seguimiento'}>
                            <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">
                                Seguimiento de proyectos
                            </h2>
                        </Link>
                        <FaChevronRight className="text-orange-500 text-2xl" />
                        <Link to={`/home/seguimiento/${id}`}>
                            <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">
                                {capitalizeWords(client.nombreComercial)}
                            </h2>
                        </Link>
                        <FaChevronRight className="text-orange-500 text-2xl" />
                        <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">
                            {activeServices}
                        </h2>
                    </div>
                </div>
            </div>

            {serviceDetails.length > 0 ? (
                <Draggable showMiniMap={false}>
                    <div className="overflow-y-auto overflow-x-auto w-full mx-auto pb-4 h-[80vh] border-b">
                        <table className="w-full relative text-sm text-left text-gray-500">
                            <thead className="text-xs sticky top-0 z-20 text-gray-900 uppercase bg-gray-200">
                                <tr>
                                    <th scope="col" className="px-6 py-3">Detalles</th>
                                    <th scope="col" className="px-6 py-3 text-center">ID</th>
                                    <th scope="col" className="px-6 py-3 text-center">Estado</th>
                                    <th scope="col" className="px-6 py-3 text-center">N° Tareas completadas</th>
                                    <th scope="col" className="px-6 py-3 text-center">N° Objetivos completados</th>
                                    <th scope="col" className="px-6 py-3 text-center">N° Fases completadas</th>
                                    <th scope="col" className="px-6 py-3 text-center">Porcentaje proyecto</th>
                                    <th scope="col" className="px-6 py-3 text-center">Fecha inicio</th>
                                    <th scope="col" className="px-6 py-3 text-center">Fecha fin</th>
                                    <th scope="col" className="px-6 py-3 text-center">Encuesta</th>
                                    <th scope="col" className="px-6 py-3 text-center">Cotización</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceDetails.map((service) => (
                                    <ItemRowSeguimientoServiciosCliente
                                        key={service.id}
                                        client={client.id}
                                        service={service}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Draggable>
            ):(
                <div className="flex flex-row justify-center items-center h-[80vh] gap-4 border-b">
                    <FaSpinner className="animate-spin text-gray-500" />
                    <span className="text-gray-600">Cargando, por favor espera...</span>
                </div>
            )}

        </div>
    )
}

export default SeguimientoServiciosCliente